import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  env: {
    width: '25%',
    background: 'transparent',
    minHeight: '125px',
    border: '2px solid rgb(172,172,172, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '1rem',
    borderRadius: '1rem',
    color: '#e8e8e8',
    textTransform: 'uppercase',
    fontSize: theme.size.base,
    textAlign: 'center',
    flexDirection: 'column',
    cursor: 'pointer',

    [theme.breakpoints.down('lg')]: {
      width: '100%',
      minHeight: '100px'
    }
  },

  active: {
    width: '25%',
    background: 'transparent',
    minHeight: '125px',
    border: '2px solid white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '1rem',
    borderRadius: '1rem',
    color: 'white',
    textTransform: 'uppercase',
    fontSize: theme.size.base,
    textAlign: 'center',
    flexDirection: 'column',

    [theme.breakpoints.down('lg')]: {
      width: 'inherit',
      minHeight: '100px'
    }
  },

  name: {
    display: 'flex',
    alignItems: 'center',
    padding: '2rem 1rem 1rem 1rem',

    [theme.breakpoints.down('lg')]: {
      padding: '1rem 0.5rem 0.25rem 0.5rem'
    }
  }
}))

export default useStyles
